import { Injectable } from '@angular/core';

import { CriterionAdditionApiRoute } from '@app/core/models/api.models';
import { CriterionAdditionApiService } from '@app/core/api/customers/criterion-addition/criterion-addition-api.service';

@Injectable({
  providedIn: 'root',
})
export class DestinationAdgroupsApiService extends CriterionAdditionApiService {
  readonly criterionAdditionRoute = CriterionAdditionApiRoute.DestinationAdgroups;
}
